


































import { Component,Prop,Vue,Watch } from 'vue-property-decorator';
import store from '@/store';
import * as $ from 'jquery';
import RecipientLookupMobile from '@/components/MobileComponents/ForwardLetterMobile/RecipientLookupMobile/RecipientLookupMobile.vue';
import FastSendRecipientSelectorMobile from '@/components/MobileComponents/FastSendMobile/FastSendRecipientSelectorMobile/FastSendRecipientSelectorMobile.vue';
import { LetterOwnerWithFaxAndEmails } from '@/store/models/LetterOwner/LetterOwnerWithFaxAndEmails';
import { LetterOwnerForSendingFaxAndEmailAndSms } from '@/store/models/LetterOwner/LetterOwnerForSendingFaxAndEmailAndSms';
import * as letterOwnerService from '@/store/Services/letterOwnerService';

  @Component({
    components:{RecipientLookupMobile, FastSendRecipientSelectorMobile}
    })
  export default class CustomAccardion extends Vue {
    recipients: LetterOwnerWithFaxAndEmails[] = [];
    selectedTypeRecipients:  LetterOwnerForSendingFaxAndEmailAndSms [] = [];
    // titile='';
    // autoCompleteDataType='';
    @Prop() titile?: string;
    @Prop() autoCompleteDataType?: string;

    created(){
        console.log(this.recipients)
        console.log(this.selectedTypeRecipients)
    }
    mounted(){
        $('#customAccordion').accordion();
    }

    selectRecipient(recipient: LetterOwnerWithFaxAndEmails){
        $('#fastSendAccordion').accordion('close',0);
        const addedItem =  this.selectedTypeRecipients.find(item=>item.id === recipient.id);
        if(!addedItem){
            this.selectedTypeRecipients.push(letterOwnerService.getLetterOwnerForSendingFaxAndEmailAndSms(recipient));
        }   
    }
    onRecipientRemoved(id: string){
        let list = [] as LetterOwnerForSendingFaxAndEmailAndSms[];
        list = this.selectedTypeRecipients;
        const removedItem =  list.find(item=>item.id === id);
        if(!removedItem)return;
        const index =  list.indexOf(removedItem);
        list.splice(index,1);        
    }
  }
